import { useState } from "react";
import styled from "styled-components";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import AtomH2 from "Components/Atoms/H2";
import AtomPaper from "Components/Atoms/Paper";
import { typography } from "globalConstants";

export type PropsType = any;

const Wrap = styled(AtomPaper)``;

const TextWrap = styled.div`
   display: flex;
   flex-direction: row;
   gap: 13px;
   margin-top: 22px;
`;
const Text = styled.pre`
   ${typography.other.t8}
   white-space: pre-wrap;
`;
const Purple = styled.a`
   ${typography.other.t10}
   color: ${typography.other.color.purple[0]};
   text-decoration-line: underline;
   cursor: pointer;
`;
const Label = styled.label`
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-top: 10px;
`;
const Check = styled.input``;
const LabelText = styled.div`
   ${typography.other.t10}
`;

function TermsDialog(props: any) {
   return (
      <Dialog open={props.shows} onClose={props.onClose} scroll="body" aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
         <DialogTitle id="scroll-dialog-title">개인 정보 취급 방침</DialogTitle>
         <DialogContent dividers={false}>
            <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
               <Text>
                  {`주식회사 아트맵은 고객의 정보를 소중하게 생각하며, ‘정보통신망 이용 촉진 및 정보보호 등에 관한 법률', ‘개인정보보호법’ 등 개인정보보호법령을 철저히 준수합니다.
주식회사 아트맵은 아래와 같은 [개인정보 처리방침]을 제정하고 이를 준수합니다. 또한, 본 개인정보 처리방침은 개인정보와 관련한 법령의 변경이 있는 경우 또는 주식회사 아트맵 정책 변경 등의 이유로 변경 될 수 있습니다. 고객 여러분들께서는 주식회사 아트맵 제공하는 사이트 방문 시 개인정보 처리방침을 수시로 확인하여 주시기 바랍니다.

1. 개인정보의 처리 목적

고객은 사이트 회원 가입시 회원 약관, 개인정보 수집 및 이용 내용에 대해 「동의함」 버튼을 클릭할 수 있는 절차를 마련하여, 「동의함」 버튼을 클릭하면 개인정보 수집 및 이용에 대해 동의한 것으로 봅니다. 주식회사 아트맵은 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다. - 고객 가입의사 확인, 고객에 대한 서비스 제공에 따른 본인 식별.인증, 회원자격 유지.관리, 서비스 이용 및 상담, 공지사항 전달, 서비스 공급에 따른 금액 결제, 서비스의 공급, 제작상품 연계서비스 제공 등

회사는 이미 동의한 개인의 수집과 이용에 대하여 ⌜취소⌟ 또는 ⌜철회⌟ 기능을 제공함으로써 언제든지 취소하고 삭제할 수 있는 방법을 제공하고 있습니다. 만약, 수집 이용동의를 철회하는 경우에는 해당 서비스의 이용은 불가능합니다.

2. 개인정보의 처리 목적

주식회사 아트맵은 정보주체로부터 개인정보를 수집할 때 동의 받은 개인정보 보유 및 이용기간 또는 법령에 따른 개인정보 보유 및 이용기간 내에서 개인정보를 처리, 보유합니다. 고객의 개인정보는 회원탈퇴 등 수집 및 이용목적이 달성되거나 동의철회 요청이 있는 경우 지체없이 파기됩니다. 단, 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관련법령의 규정에 의하여 다음과 같이 거래 관련 권리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 그 기간 동안 보유합니다.

가. 「전자상거래 등에서의 소비자보호에 관한 법률」 제6조

- 계약 또는 청약 철회 등에 관한 기록 : 5년

- 대금결재 및 재화 등의 공급에 관한 기록 : 5년

- 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년

나. 「통신비밀보호법」 제15조

- 방문(로그)에 관한 기록: 1년

다. 기타 관련 법령 등

회사의 개인정보 파기 방법은 다음과 같습니다

가. 파기 절차

① 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 의한 일정 기간 저장된 후 파기됩니다.

② 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.

나. 파기 방법

① 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.

② 종이에 출력된 개인정보가 있는 경우 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.

회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제29조 제2항에 따라 휴면 회원(최근 12개월 동안 서비스를 이용하지 아니한 회원)에 대해 회원자격 상실에 대한 안내문을 통지하고, 안내문에서 정한 기한 내에 답변이 없을 경우 회원자격을 상실시킬 수 있습니다.

이 경우, 휴면 회원의 개인정보는 다른 회원의 개인정보와 분리하여 별도로 저장·관리 되며, 분리 저장된 개인정보는 법정보관기간 경과 후 파기하고 있습니다.

파기되지 않은 개인 정보 중 해당 이용자의 요청이 있는 경우 고객 정보는 서비스 이용을 재개하는 시점에 다시 제공됩니다.


3. 처리하는 개인정보의 항목 작성


1. 주식회사 아트맵은 다음의 개인정보 항목을 처리하고 있습니다.


분류	유형	수집 및 이용 항목	수집 및 이용 목적	보유 기간
이용자 정보	이용자 식별(회원가입)	[일반회원]이름, 이메일주소[갤러리 관리자]이름, 이메일주소, 상호명, 직책, 휴대폰 번호, [작가]이름, 이메일주소, 비밀번호, 휴대폰 번호	이용자의 식별 및 본인 확인개인전문투자자 적격 확인부정이용 확인·방지회원 서비스 제공서비스 이용에 대한 공지 및 상담민원처리	회원 탈퇴 시 즉시 삭제· 부정이용 방지를 위한 정보(ID, 불량이용 기록)는 탈퇴 DB에서 6개월 후 삭제· 불만 또는 분쟁처리에 관한 기록은 3년간 보관(전자상거래 등에서의 소비자 보호에 관한 법률)
주문/결제	[결제수단 선택에 따른 수집]· 신용카드 : 카드사명, 카드번호(일부) 등· 무통장입금 : 은행명, 입금자명· 현금영수증 발급 정보 : 휴대전화번호, 현금영수증카드정보· 세금계산서 발급 정보 : 전자세금계산서 발급용 이메일, 사업자등록번호, 사업자등록증 사본(이름, 주소, 휴대전화, 이메일)	주문 상품의 결제 및 환불계약사항 및 주문내역 안내 등 고지부정이용 확인·방지 관리	회원 탈퇴 시 즉시 삭제· 부정이용 방지를 위한 고객 식별정보(CI, DI)는 탈퇴 DB에서 6개월 후 삭제· 거래기록 보존을 위해 소비자 식별정보(CI, DI), 결제·취소·환불 및 배송 정보는 5년간 보관(전자상거래 등에서의 소비자 보호에 관한 법률)
환불	예금주 성명, 은행명, 계좌번호
서비스 이용 기록	단말기정보(OS, 화면사이즈, 디바이스 아이디, 폰기종, 단말기 모델명), IP주소, 쿠키, 방문일시, 부정이용기록, 서비스 이용 기록 등	서비스 이용 기록 통계 분석 등 품질 관리/소비자 보호를 위한 법적 의무 준수/부정 이용확인·방지관리/회원 간 분쟁 조정/상품(경품) 발송을 위한 발송정보 확인	회원 탈퇴 시 즉시 삭제· 서비스 이용기록은 3개월간 보관 (통신비밀보호법)·안심번호 서비스 이용기록(음성 녹취 파일)은 1개월간 보관
2. 수집 방법

가. 회사는 ‘개인(신용)정보 수집, 이용동의’에 대해 「동의함」 또는 「동의하지 않음」 버튼을 클릭할 수 있는 절차를 마련하여, 「동의함」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.
나. 회사는 다음과 같은 방법으로 개인정보를 수집합니다.

● 가입 및 서비스 이용과정에서 고객이 개인정보 수집에 대해 동의 후 직접 정보를 입력하는 경우

● 고객센터를 통한 문의 과정에서 웹페이지, 전화, 메일, 팩스, 서면 등

● 온·오프라인에서 진행되는 이벤트/행사 등 응모 및 참여



4. 개인정보의 제3자 제공에 관한 사항

주식회사 아트맵은 고객의 개인정보를 "제1조 개인정보의 수집항목 및 이용목적 "에서 고지한 범위를 넘어 이용하거나 타인 또는 타기업, 기관에 제공하지 않습니다. (정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에는 개인정보를 제3자에게 제공할 수 있습니다).

단, 다음은 예외로 합니다.

가. 관계법령에 의하여 수사상의 목적으로 관계 기관으로부터의 요구가 있을 경우

나. 통계작성, 학술연구나 시장조사 등을 위하여 특정 개인을 식별할 수 없는 형태로 광고주, 협력사나 연구단체 등에 제공하는 경우

다. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우

상기사항에 의해 개인정보를 제공하는 경우에도 본래의 수집∙이용 목적에 반하여 무분별하게 정보가 제공되지 않도록 최대한 노력하겠습니다.



[제3자 제공현황]
현재 없음



5. 개인정보 처리 위탁에 관한 사항


회사는 더 나은 서비스를 제공하기 위하여 정보주체의 개인정보 처리를 외부전문기관에 위탁할 수 있습니다.

가. 회사는 개인정보 처리를 위탁하는 경우 위탁하는 업무의 내용과 수탁자를 정보주체가 언제든지 쉽게 확인할 수 있도록 회사의 인터넷 홈페이지에 지속적으로 게재하여 공개합니다. 특히, 회사가 재화 또는 서비스를 홍보하거나 판매를 권유하는 업무를 위탁하는 경우에는 서면, 전자우편, 팩스, 전화, 문자전송 또는 이에 상당하는 방법(이하 "서면 등의 방법"이라 합니다)으로 위탁하는 업무의 내용과 수탁자를 정보주체에게 알려드립니다. 위탁하는 업무의 내용이나 수탁자가 변경된 경우에도 동일합니다. 만약, 회사가 과실 없이 서면 등의 방법으로 정보주체에게 알릴 수 없는 경우에는 해당 사항을 인터넷 홈페이지에 30일 이상 게재합니다.

나. 회사는 수탁자에게 다음의 내용이 포함된 문서에 의하여 개인정보의 처리 업무를 위탁하고 있으며, 당해 문서를 서면 또는 전자적으로 보관하여 정보주체의 권익을 보호합니다.

● 위탁업무의 목적 및 범위
● 위탁업무 수행 목적 외 개인정보의 처리 금지에 관한 사항
● 재위탁 제한에 관한 사항
● 개인정보의 기술적·관리적 보호조치에 관한 사항
● 개인정보에 대한 접근 권한 등 안전성 확보 조치에 관한 사항
● 위탁업무와 관련하여 보유하고 있는 개인정보의 관리 현황 점검 등 감독에 관한 사항
● 수탁자가 준수하여야 할 의무를 위반한 경우의 손해배상 등에 관한 사항


[취급위탁현황]

업체명	제공하는 항목	제공받는 자의 이용목적	보유 및 이용기간
(주)다날	이름, 전화번호, 카드, 결제 시 카드사 명, 카드번호	결제처리(신용카드, 무통장 입금 및 기타 결제수단)	회원 탈퇴 시, 서비스 종료 시 혹은 위탁 계약 종료 시까지- 부정이용 방지를 위한 고객 식별정보 (CI, DI)는 탈퇴 DB에서 6개월 후 삭제.- 거래기록 보존을 위해 소비자 식별정보(CI, DI), 결제, 취소환불 및 배송 정보는 5년간 보관(전자삼거래 등에서의 소비자보호에 관한 볍률)
NICE평가정보	이름, 전화번호, 개인식별번호	본인인증	회원 탈퇴 시, 서비스 종료 시 혹은 위탁 계약 종료 시까지- 부정이용 방지를 위한 고객 식별정보 (CI, DI)는 탈퇴 DB에서 6개월 후 삭제.- 거래기록 보존을 위해 소비자 식별정보(CI, DI), 결제, 취소환불 및 배송 정보는 5년간 보관(전자삼거래 등에서의 소비자보호에 관한 볍률)
(주)채널코퍼레이션	이름, 이메일, 전화번호	고객 문의 관리	회원 탈퇴 시, 서비스 종료 시 혹은 위탁 계약 종료 시까지- 서비스 이용기록은 3개월간 보관 (통신비밀보호법)- 안심번호 서비스 이용기록(음성 녹취 파일)은 1개월간 보관
스티비 주식회사	이름, 이메일	이메일 발송	회원 탈퇴 시, 서비스 종료 시 혹은 위탁 계약 종료 시까지
KT 클라우드	서비스 이용 기록 또는 수집된 개인 정보	데이터 보관 및 시스템 운영	회원 탈퇴 시, 서비스 종료 시 혹은 위탁 계약 종료 시까지


6. 정보주체와 법정대리인의 권리·의무 및 그 행사방법


고객은 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.

① 정보주체는 주식회사 하프스에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.

가. 개인정보 열람요구

나. 오류 등이 있을 경우 정정 요구

다. 삭제요구

라. 처리정지 요구

② 개인정보 열람 및 정정을 하고자 할 경우에는 홈페이지 『회원정보』 항목을 클릭하여 직접 열람 또는 정정하거나, 고객센터로 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다. 또한, 회원가입 등을 통해 개인정보의 수집, 이용, 제공에 대해 고객께서 동의하신 내용을 고객께서는 언제든지 철회하실 수 있습니다. 동의 철회를 하고 개인정보를 파기하는 등의 조치를 취한 경우에는 그 사실을 고객께 지체 없이 통지하도록 하겠습니다.


7. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항


① 회사는 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.

② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.

가. 쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.

나. 쿠키의 설치•운영 및 거부 : 웹브라우저 상단의 도구&gt;인터넷 옵션&gt;개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.

다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.



8. 개인정보의 안전성 확보 조치


회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 조치를 하고 있습니다.

① 기술적 대책

회사는 개인정보처리시스템 등의 접근권한 관리를 통해 외부로부터의 무단 접근을 통제하고 있으며, 중요 데이터는 저장 및 전송시 암호화하여 사용하는 등 안전하게 저장•관리하고 있습니다.

회사는 해킹이나 악성코드 등에 의한 개인정보 유출 및 훼손을 방지하기 위하여 보안프로그램을 주기적으로 갱신•점검하고 있습니다.

회사는 결제 등의 경우에 있어 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 보안장치를 채택하고 있습니다.

회사는 해킹 등에 의한 정보의 유출을 방지하기 위해 침입차단시스템(방화벽)을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적인 보안성을 확보하기 위해 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.

② 관리적 대책

회사는 회원 본인의 비밀번호 요청 등에 의해 개인정보를 다룰 때 가능한 최선의 방법으로 본인임을 확인하고 안전하게 정보가 처리될 수 있도록 최선을 다합니다.

회사는 개인정보에 대한 접근권한을 개인정보관리책임자 등 개인정보관리업무를 수행하는 자, 기타 업무상 개인정보의 취급이 불가피한 자로 제한하며, 개인정보를 취급하는 직원에 대한 수시 교육을 통하여 개인정보취급방침의 준수를 항상 강조하고 있습니다.

회사의 안정성 확보 조치 이외에 회원은 아이디와 비밀번호, 주민등록번호 등 개인정보가 인터넷 상에 노출되거나 타인에게 유출되지 않도록 주의하여야 합니다. 회원 본인의 부주의나 관리소홀로 아이디와 비밀번호 등 개인정보가 유출되었다면 이에 대해서 회사는 책임을 지지 않습니다. 따라서, 회원의 아이디와 비밀번호는 반드시 본인만 사용하시고, 비밀번호를 자주 바꿔주시는 것이 좋으며, 비밀번호는 영문자, 숫자를 혼합하여 타인이 유추하기 어려운 번호를 사용하는 것이 좋습니다.

또한 서비스의 이용을 마친 후에는 항상 로그아웃을 하여 주시고 웹 브라우저를 종료하는 것이 좋습니다. 특히, 다른 사람과 컴퓨터를 공유하거나, 공공장소에서 이용하는 경우에 개인정보의 보안을 위해서는 이와 같은 절차가 더욱 필요합니다.



9. 이용자의 의무


고객님의 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를 예방해 주시기 바랍니다. 입력한 부정확한 정보로 인해 발생하는 사고의 책임은 이용자 자신에게 있으며 타인 정보의 도용 등 허위정보를 입력할 경우 회사 회원자격이 상실되거나 회사 홈페이지 이용이 정지될 수 있습니다.

이용자 개인정보와 관련한 아이디(ID)의 비밀번호에 대한 보안유지책임은 해당 이용자 자신에게 있습니다. 회사는 비밀번호에 대해 어떠한 방법으로도 이용자에게 직접적으로 질문하는 경우는 없으므로 타인에게 비밀번호가 유출되지 않도록 각별히 주의하시기 바랍니다.

고객님은 개인정보를 보호받을 권리와 함께 스스로를 보호하고 타인의 정보를 침해하지 않을 의무도 가지고 있습니다. 게시물을 포함한 타인의 개인정보를 훼손하지 않도록 유의해 주십시오.

만약 이 같은 책임을 다하지 못하고 타인의 정보를 훼손할 시에는 관계 법령 등에 의해 처벌받을 수 있습니다.특히, 공공장소에서 온라인상에서 접속해 있을 경우에는 더욱 유의하셔야 합니다.


10. 14세 미만 아동의 개인정보보호 방침

회사는 법정대리인의 동의가 필요한 만 14세 미만 아동의 회원가입은 받고 있지 않습니다.

11. 개인정보보호 담당부서

회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 개인정보관리책임자를 지정하고 있습니다.

- 개인정보관리책임자 성명 : 최선연

- 전화번호 : 070-7743-1267

- 이메일 : info@art-map.co.kr

개인정보침해에 대한 신고 또는 상담이 필요하신 경우에는 한국정보보호진흥원(KISA) 개인정보침해신고센터로 문의하시기 바랍니다. 또한, 귀하가 개인정보침해를 통한 금전적, 정신적 피해를 입으신 경우에는 한국정보보호진흥원*KISA) 개인정보분쟁조정위원회에 피해구제를 신청하실 수 있습니다.

- KISA 개인정보보호 (http://privacy.kisa.or.kr / (국번 없이) 118)

- 경찰청 사이버안전국 ( http://cyberbureau.police.go.kr (국번없이) 182 )

- 대검찰청 사이버수사과 ( http://spo.go.kr / 02-3480-3570 )

- 개인정보 침해신고센터 (한국인터넷 진흥원 운영) ( http://privacy.kisa.or.kr / (국번없이) 118 )

- 개인정보 분쟁조정위원회 (한국인터넷 진흥원 운영) (http://www.kopico.go.kr / 1833-6972).

12. 개인정보 처리방침 변경

① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다. 다만, 수집하는 개인정보의 항목, 이용목적의 변경 등과 같이 이용자 권리의 중대한 변경이 발생할 때에는 최소 30일 전에 미리 알려드리겠습니다.

이 개인정보 처리방침의 공고 및 시행일자는 아래와 같습니다.

- 공고일자 : 2022년 02월 10일

- 시행일자 : 2022년 02월 10일

*회원이 본 개정에 이의가 있을 경우 본 고지를 받은 날로부터 1개월 이내에 회원탈퇴를 요청할 수 있습니다. 해당기간 안에 별도 의사표시가 없는 경우 개정에 동의한 것으로 간주합니다.
`}
               </Text>
            </DialogContentText>
         </DialogContent>
         <DialogActions>
            <Button onClick={props.onClose}>닫기</Button>
         </DialogActions>
      </Dialog>
   );
}
export default function OrganismForm1_2(props: PropsType) {
   const [showsDialog, setShowsDialog] = useState(false);

   function dialogOnClose() {
      setShowsDialog(false);
   }

   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <AtomH2>1-2. 약관 동의</AtomH2>
         <TextWrap>
            <Text>견적 제공을 위해 약관 동의를 부탁드립니다.</Text>
            <Purple onClick={() => setShowsDialog(true)}>약관 확인</Purple>
         </TextWrap>
         <TermsDialog shows={showsDialog} onClose={dialogOnClose}></TermsDialog>
         <Label>
            <Check type="checkbox" onChange={props.checkOnChange}></Check>
            <LabelText>회원가입 약관 및 개인정보 취급 방침에 동의합니다.</LabelText>
         </Label>
      </Wrap>
   );
}
